// extracted by mini-css-extract-plugin
export default {"section":"AboutUsPage_section__hwgC4","heading":"AboutUsPage_heading__JErhn","carousel":"AboutUsPage_carousel__8hWH8"};